import {HalImageRef} from "@cm/hal/hal-ref"
import {Descriptor, MipLevelRegion, Regions} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/image-op-descriptor"
import {ImageOpContextHal} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/image-op-context-hal"
import {RegionLockedHalImageRef} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/hal/region-locked-hal-image-ref"
import {HalImage} from "@cm/hal"
import {ExtUpdateImageOptions, UpdateImageOptions} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/hal/image-op-hal-types"
import {TrackedRefCountableBase} from "@cm/utils"

export type WriteOutputImageRegionFunction = (outputImage: HalImage, mipLevelRegion: MipLevelRegion, options?: UpdateImageOptions) => Promise<void>
export type SubSampleRegionFunction = (targetImage: HalImage, sourceImage: HalImage, mipLevelRegion: MipLevelRegion) => void

export abstract class ImageOpHalOutputImage extends TrackedRefCountableBase {
    debugId?: string

    abstract get outputImagePtr(): HalImageRef

    abstract invalidateRegions(regions: Regions): void
    abstract getUpdatedHalImage(
        writeRegionFn: WriteOutputImageRegionFunction,
        subSampleRegionFn: SubSampleRegionFunction,
        mipLevelRegion: MipLevelRegion,
        options: ExtUpdateImageOptions,
    ): Promise<RegionLockedHalImageRef>

    constructor(
        readonly ctx: ImageOpContextHal,
        readonly descriptor: Descriptor,
    ) {
        super({
            disposeFn: () => this.dispose(),
        })
    }

    protected dispose() {}
}
